import React, { useState, useEffect } from 'react';
import { List, Avatar, Card, Skeleton } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './Home.less';

interface Post {
  id: number;
  title: string;
  content: string;
  author: {
    name: string;
    avatar: string;
  };
  date: string;
}

const Home: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 模拟API调用获取数据
    const fetchPosts = async () => {
      // 模拟网络延迟
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // 生成模拟数据
      const mockPosts: Post[] = Array.from({ length: 10 }, (_, index) => ({
        id: index + 1,
        title: `文章标题 ${index + 1}`,
        content: `这是文章内容 ${index + 1}。这里包含了文章的详细描述信息，展示了文章的主要内容和关键点。用户可以通过阅读这些内容来了解文章的核心思想。`,
        author: {
          name: `用户${String.fromCharCode(65 + index % 26)}`,
          avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=user${index + 1}`
        },
        date: new Date(Date.now() - index * 86400000).toLocaleDateString()
      }));
      
      setPosts(mockPosts);
      setLoading(false);
    };

    fetchPosts();
  }, []);

  return (
    <div className="home-container">
      <List
        className="post-list"
        loading={loading}
        itemLayout="vertical"
        dataSource={posts}
        renderItem={(post) => (
          <List.Item
            key={post.id}
            actions={[
              <span key="date">{post.date}</span>
            ]}
            extra={
              <img
                width={200}
                alt="文章缩略图"
                src={`https://picsum.photos/400/300?random=${post.id}`}
              />
            }
          >
            <Skeleton loading={loading} avatar title paragraph={{ rows: 2 }} active>
              <List.Item.Meta
                avatar={
                  <Avatar src={post.author.avatar} icon={<UserOutlined />} />
                }
                title={<a href={`#post-${post.id}`}>{post.title}</a>}
                description={`作者：${post.author.name}`}
              />
              <Card className="post-card">
                <p className="post-content">{post.content}</p>
              </Card>
            </Skeleton>
          </List.Item>
        )}
      />
    </div>
  );
};

export default Home;